import { useContext, useEffect, useRef, useState } from "react";
import Context from "./Context";
import styled from "styled-components";
import { Oval } from 'react-loader-spinner';
const API_KEY = "AIzaSyBFNqecLsLxY_bv1ITuhE1s3uB5bqWonws";
export default function Inicial() {
  const { setId } = useContext(Context);
  const [loading,setLoading]=useState(false)
  const [texto, setTexto] = useState("");
  const [nextPageToken, setNextPageToken] = useState(false);
  const textoRef = useRef("");
  const [results, setResults] = useState([]);

  function extrairId(txt) {
    if(txt.includes('youtu.be')){
        const lis=txt.split('/')
        const fim=lis[lis.length-1]
        const [inicio]=fim.split('?')
        setId(inicio);
    }else{
      const parte = txt.replace("https://www.youtube.com/watch?v=", "");
      const inicio = parte.includes("&") ? parte.split("&")[0] : parte;
      setId(inicio);
    }
  }
  async function handleSearch(txt,pageToken) {
    if (!txt) return;
    setLoading(true)
    const res = await fetch(
      `https://www.googleapis.com/youtube/v3/search?part=snippet&q=${encodeURIComponent(
        txt
      )}${pageToken?`&pageToken=${nextPageToken}`:''}&type=video&maxResults=10&key=${API_KEY}`
    );
    const data = await res.json();
    setLoading(false)
    setNextPageToken(data.nextPageToken)
    if(pageToken){
      setResults([...results,...data.items])
    }else{
      setResults(data.items || []);
    }
    
  }
  function distribuir(txt = textoRef.current) {
    
    if (!txt) return;
    if (txt.includes("youtu")) {
      extrairId(txt);
    } else {
      handleSearch(txt);
      setNextPageToken(false)
    }
  }

  useEffect(() => {
    textoRef.current = texto;
  }, [texto]);
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        distribuir();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <Tudo>
      <section>
      <input
        value={texto}
        onChange={(e) => setTexto(e.target.value)}
        placeholder="Pesquise ou cole o link do youtube..."
      />

      <button onClick={() => distribuir()}>OK</button>
      </section>
      <Resultados>
        {loading&&!nextPageToken?
        <Holder>
          <Oval height={100} width={100} color="#ffffff" wrapperStyle={{}} wrapperClass="" visible={true} ariaLabel="oval-loading"/>
        </Holder>
        :results.map((item) => (
          <Video
            key={item.id.videoId}
            onClick={() => setId(item.id.videoId)}
          >
            <img
              src={item.snippet.thumbnails.medium.url}
            />
            <section>
            <h1>{item.snippet.title}</h1>
            <h2>{item.snippet.channelTitle}</h2>
            </section>
          </Video>
        ))}
        {results.length>0?
      !loading?<button  onClick={() => handleSearch(texto,nextPageToken)}>Mais vídeos</button>
      :nextPageToken?
      <Holder>
          <Oval height={100} width={100} color="#ffffff" wrapperStyle={{}} wrapperClass="" visible={true} ariaLabel="oval-loading"/>
        </Holder>:<></>
      :<></>}
      </Resultados>
      
    </Tudo>
  );
}
const Tudo=styled.div`
position:sticky;top:0;
width:calc(100% - 200px);
height:100%;
flex-direction:column;
section{padding-right:20px;}
padding:20px 0px 0 20px;
input{
margin-right:20px;
padding:10px;box-sizing:border-box;
border-radius:10px;border:0;
width:450px;
height:50px;
max-width:calc(100% - 100px)
}
button{
background:#38dd35;
cursor:pointer;
width:80px;
height:50px;
border-radius:10px;border:0;
}
@media(max-width:850px){
width:100%
}
`
const Holder=styled.div`
justify-content:center;
align-items:center;
height:500px;
width:500px;
max-width:100%;
`
const Resultados=styled.div`
flex-direction:column;
height:calc(100% - 80px);
width:650px;max-width:100%;
overflow-y:auto;
overflow-x:hidden;
margin-top:20px;
button{

background:#8989b2;
margin-bottom:10px;
cursor:pointer;
width:98%;
min-height:50px;
border-radius:10px;border:0;
}
`
const Video=styled.div`
cursor:pointer;
padding:10px;margin-bottom:10px;
background:white;
width:98%;
border-radius:10px;
img{height:100px;width:160px;margin-right:10px;}
section{
h1{margin:0;font-size:16px;font-weight:400;line-height:20px;}
h2{margin:0;font-size:14px;font-weight:400;color:gray;}
}
@media(max-width:650px){
img{height:75px;width:120px;margin-right:10px;}
}
`


